import { getTypeFromFileTypeName } from '@office-start/file-utility';
export function appListToFileTypeSet(apps) {
    return new Set(apps.reduce(function (acc, app) {
        var fileType = getTypeFromFileTypeName(app);
        return fileType ? acc.concat(fileType) : acc;
    }, []));
}
//# sourceMappingURL=appListToFileTypeSet.js.map